import { render } from "./DlAuxDistributionSection.vue?vue&type=template&id=cb51053c&scoped=true"
import script from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"
export * from "./DlAuxDistributionSection.vue?vue&type=script&lang=js"

import "./DlAuxDistributionSection.vue?vue&type=style&index=0&id=cb51053c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb51053c"]])

export default __exports__